import { HTTPVerb } from '../Modules/Utils/API/Interfaces/IApi';
import { ApiManager } from '../Modules/Utils/API/ApiManager';

enum APIConstants {
    Get = '/api/openregistration',
}

export default class OpenRegistrationApi {
    public static GetOpenRegistration = async (): Promise<any> =>
        ApiManager.getAPIInstance().request({
            url: APIConstants.Get,
            method: HTTPVerb.GET,
        });
}
